import { render, staticRenderFns } from "./BundlePackagesSection.vue?vue&type=template&id=3f314757"
import script from "./BundlePackagesSection.vue?vue&type=script&lang=js"
export * from "./BundlePackagesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports